// extracted by mini-css-extract-plugin
export var actionButton = "_9b-0";
export var attachmentLine = "_9b-1";
export var fileInput = "_9b-2";
export var fileUploadWrapper = "_9b-4";
export var footer = "_9b-3";
export var modalContent = "_9b-5";
export var paperclip = "_9b-6";
export var quillEditor = "_9b-7";